import { useState } from "react";
import Loading from "../../common/components/Loading";
import { getImageUrl } from "../../common/helpers/common";

function ProfilePicture({ profile, userUpdate, setUpdatingField, isLoading }) {
  const [errorMessage, setErrorMessage] = useState("");

  const allowedTypes = ["image/jpeg", "image/png", "image/svg+xml"]; // Allowed file types
  const maxFileSize = 5 * 1024 * 1024; // 5MB in bytes

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && allowedTypes.includes(file.type) && file.size <= maxFileSize) {
      setErrorMessage("");

      const formData = new FormData();
      formData.append("profilePic", file);

      setUpdatingField("profilePic");
      userUpdate(formData);
    } else {
      setErrorMessage(
        file
          ? "Please select a valid image file (JPEG, PNG) under 5MB."
          : "No file selected."
      );
    }
  };

  return (
    <div>
      <div className="w-32 h-32 bg-gray-200 rounded-md overflow-hidden">
        {isLoading ? (
          <div className="flex justify-center items-center h-full">
            <Loading />
          </div>
        ) : (
          <img
            src={getImageUrl(profile) || "./images/icons/profile-account.svg"}
            alt="profile"
            className="object-cover w-full h-full"
          />
        )}
      </div>

      <div className="mt-6">
        <label
          htmlFor="file-upload"
          className="cursor-pointer common_bg text-white py-2 px-4 rounded-lg shadow-md nav_link-700 transition duration-300 text-sm"
        >
          Change profile
        </label>
        <input
          id="file-upload"
          type="file"
          className="hidden"
          onChange={handleFileChange}
          disabled={isLoading}
        />

        <div className="text-red-600 mt-2 text-sm">{errorMessage}</div>
      </div>
    </div>
  );
}

export default ProfilePicture;
